import React from 'react';

function StoryContentCaption({ content, characterCount }) {
  if (!content) return null;

  return (
    <div className="story-content-caption-container">
      <div className="story-content-caption">
        {content.split('\n').map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
      <div className="caption-character-count">
        {characterCount} characters
      </div>
    </div>
  );
}

export default StoryContentCaption;
